import React from 'react';
import { Helmet } from 'react-helmet';
import PortfolioSite from '../components/Portfolio/PortfolioSite';
import '../style/portfolio.scss';

export default function IndexPage() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Simeon Leatherland</title>
        <html lang="en" />
        <meta name="description" content="Simeon Leatherland — disc jockey, radio, tech" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400;600&display=swap"
          rel="stylesheet"
        />
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-8BK5GL7Q4W" />
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-8BK5GL7Q4W');
          `}
        </script>
      </Helmet>
      <PortfolioSite />
    </>
  );
}
